import { AppointmentEventSlotData } from '~libs.shared.appointments-timetable';

export const filterCancelledAppointmentEventsSlots = (
   eventsSlots: AppointmentEventSlotData[]
): AppointmentEventSlotData[] => {
   return eventsSlots.filter((eventSlot) => {
      return eventSlot.status !== 'CANCELLED' && eventSlot.visit?.status !== 'CANCELLED';
   });
};
